import React from 'react';

import { ViewportImage } from "components/Image/Index";
import { ViewportVideo } from 'components/Video';

import * as fromProjects from 'store/Projects';

import { useIntersect } from 'hooks/useIntersect';

interface IProps {
  animationReady: boolean;
  bodyContent: object;
}

export const CitiesOfTheFutureClips: React.FC<IProps> = ({ animationReady, ...props }) => {
  const bodyContent: fromProjects.IContentImageBoardSection = props.bodyContent as fromProjects.IContentImageBoardSection;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const actualItem = (item: fromProjects.IContentImageBoardContent, index: number) => {
    if (item.type === 'image') {
      const image: fromProjects.IImage = item.details as fromProjects.IImage;
      return (
        <figure key={index}>
          <div className='figureWrapper'>
            <ViewportImage
              width='100%'
              heightRatio={item.details.heightRatio}
              src={'/assets/images/work/' + image.url}
              alt={image.alt}
              fit='contain'
              animateImageIn={inView}
              animationReady={inView}
              animationType={'reveal'}
            />
          </div>
        </figure>
      );
    } else if (item.type === 'video') {
      const video: fromProjects.IVideo = item.details as fromProjects.IVideo;
      return (
        <figure key={index}>
          <div className='figureWrapper'>
            <ViewportVideo
              width='100%'
              height='100%'
              heightRatio={item.details.heightRatio}
              url={'/assets/video/work/' + video.url}
              autoPlay
              muted
              playVideo={inView}
              loop
              animateVideoIn={inView}
              animationReady={inView}
              animationType='reveal'
            />
          </div>
        </figure>
      );
    }
  };

  return (
    <div ref={inViewRef} className='imageBoardWrapper citiesOfTheFutureClips'>
      <div className='column leftColumn'>
        {bodyContent.content.map((item, index) => {
          if (index < 5)
            return actualItem(item, index);
        })}
      </div>
      <div className='column rightColumn'>
        {bodyContent.content.map((item, index) => {
          if (index > 4)
            return actualItem(item, index);
        })}
      </div>
    </div>
  );
};
